import { render, staticRenderFns } from "./cwXq.vue?vue&type=template&id=0c1f6f53&scoped=true&"
import script from "./cwXq.vue?vue&type=script&lang=js&"
export * from "./cwXq.vue?vue&type=script&lang=js&"
import style0 from "./cwXq.vue?vue&type=style&index=0&id=0c1f6f53&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1f6f53",
  null
  
)

export default component.exports